import React, { useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { KeyRound } from 'lucide-react'
import { tr } from 'i18n'
import { hasAccess } from 'utils/access'
import { resetOperatorPin } from 'service/AdminPanelService'
import { getErpErrorMessage } from 'service/ErpService'
import OperatorPinResetDialog from '../OperatorPinResetDialog/OperatorPinResetDialog.tsx'
import styles from '../AdminPanelPage.module.scss'
import s from '../Management.module.scss'

export default function OperatorPinResetAction({ operator, onChanged = () => {} }) {
  useTranslation()
  const user = useSelector(state => state.user)
  const [open, setOpen] = useState(false)
  const [busy, setBusy] = useState(false)
  const busyRef = useRef(false)
  const [error, setError] = useState('')
  const [message, setMessage] = useState('')

  if (user.is_report_only || !hasAccess(user, 'operators_pin') || operator.employee === null) return null

  const confirm = async pin => {
    if (busyRef.current) return
    busyRef.current = true
    setBusy(true)
    setError('')
    setMessage('')
    try {
      await resetOperatorPin(operator.id, pin)
      setOpen(false)
      setMessage(tr('PIN сброшен. При следующем входе оператор задаст новый код.'))
      await onChanged()
    } catch (e) {
      setError(getErpErrorMessage(e, tr('Не удалось сбросить PIN оператора.')))
    } finally {
      busyRef.current = false
      setBusy(false)
    }
  }

  return <div style={{ display: 'inline-block', verticalAlign: 'top' }} onClick={event => event.stopPropagation()}>
    <button type="button" className={styles.smallBtn} aria-haspopup="dialog" aria-expanded={open} disabled={busy} onClick={() => { setError(''); setMessage(''); setOpen(true) }}>
      <KeyRound size={14} aria-hidden="true" />{tr('Сбросить PIN')}
    </button>
    {message && <p role="status" className={s.muted}>{message}</p>}
    {error && !open && <p role="alert" className={s.error}>{error}</p>}
    {open && <OperatorPinResetDialog name={operator.employee_name || ''} busy={busy} error={error}
      onClose={() => setOpen(false)} onConfirm={confirm} />}
  </div>
}
